module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"language":"EN"},"de":{"language":"DE"}}')
  delete Component.options._Ctor
}
